import { render, staticRenderFns } from "./KAppHeader.vue?vue&type=template&id=755fe78b&"
import script from "./KAppHeader.vue?vue&type=script&lang=ts&"
export * from "./KAppHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports